import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import ErrorView from "~/views/private/ErrorView";
const Wrapper = styled.section`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
`;
const Section = _ref2 => {
  let {
    s = {
      p: 14
    },
    children,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $s: s
  }, rest), /*#__PURE__*/React.createElement(ErrorView, null, children));
};
export default Section;